import React, { useContext } from "react";
import { ThemeContext } from "./ThemeProvider";

export default function ThemeToggle({ className = "" }) {
    const { theme, toggle } = useContext(ThemeContext);
    const isDay = theme === "day";

    return (
        <button
            type="button"
            onClick={toggle}
            className={
                className ||
                "inline-flex items-center gap-2 px-3 py-1.5 rounded-md border text-sm " +
                "bg-white text-gray-900 border-gray-300 hover:bg-gray-50 " +
                "dark:bg-gray-800 dark:text-gray-100 dark:border-gray-700 dark:hover:bg-gray-700"
            }
            title={isDay ? "Przełącz na ciemny" : "Przełącz na jasny"}
            aria-pressed={!isDay}
        >
            <span className="font-medium">{isDay ? "Day" : "Dark"}</span>
            <span aria-hidden>🌓</span>
        </button>
    );
}
